import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Button as RsButton } from "rsuite";
import { TolLoader, HoverOverlay, Icon } from "../index";
function Button(props) {
    const { icon, onClick, className, text, disabled, size, type, active, position = "none", tooltip, disabledTooltip, loading, outline, } = props;
    const outlineClass = outline ? "-outline" : "";
    const loader = _jsx(TolLoader, { size: "sm" });
    const button = (_jsx(RsButton, { onClick: onClick, disabled: disabled || loading, active: active, className: `icon-button-${type || "primary"}-${size || "md"}${outlineClass} ${className}`, children: loading ? (loader) : (_jsxs(_Fragment, { children: [icon && (_jsx("div", { className: "bttn-icon-div", children: _jsx(Icon, { icon: icon, size: size }) })), text && (_jsx("span", { style: { marginLeft: icon ? "6px" : "0px" }, children: text }))] })) }));
    const contents = disabled && disabledTooltip ? disabledTooltip : tooltip;
    return (_jsx("div", { style: {
            float: position,
            marginLeft: position === "right" ? "6px" : "0px",
            marginRight: position === "left" ? "6px" : "0px",
        }, children: contents ? (_jsx(HoverOverlay, { contents: contents, followCursor: disabled, delay: disabled ? undefined : 800, children: _jsx("div", { className: "tooltip-wrapper", children: button }) })) : (button) }));
}
export default Button;
